import { render, staticRenderFns } from "./typesList.vue?vue&type=template&id=6c1ea42e&scoped=true"
import script from "./typesList.vue?vue&type=script&lang=js"
export * from "./typesList.vue?vue&type=script&lang=js"
import style0 from "./typesList.vue?vue&type=style&index=0&id=6c1ea42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1ea42e",
  null
  
)

export default component.exports